<template>
  <div class="relative">
    <div class="absolute top-0 right-0 z-30 pr-5 lg:pr-3">
      <router-link
        v-if="bono != 'home'"
        :to="`/${$i18n.locale}/admin`"
        class="mr-2 text-base font-bold text-white hover:font-semibold"
      >
        {{ $t("Login establecimientos") }}
      </router-link>
      <button
        :class="`${$i18n.locale == lang ? ' font-bold ' : ' font-thin '} `"
        class="px-1 py-1 mr-2 text-base text-white uppercase rounded-full"
        v-for="(lang, i) in idiomas"
        :key="`Lang${i}`"
        @click="setLocale(lang)"
      >
        {{ $t(lang) }}
      </button>
    </div>
    <transition :name="transitionName" mode="out-in">
      <router-view class="child-view" />
    </transition>
  </div>
</template>
<script>
export default {
  created() {
    const navigatorLang = window.navigator.language;
    let lang = "--";

    if (this.$cookie.get("lang")) {
      lang = this.$cookie.get("lang");
      this.$cookie.set("lang", lang, { expires: 7 });
    } else {
      lang = navigatorLang.split("-")[0];
    }

    const idioma = this.idiomas.includes(lang);

    if (idioma) {
      this.$i18n.locale = lang;
    }
  },
  mounted() {
    // cl*('montado')
    this.scrollTop();
  },
  data() {
    return {
      idiomas: ["eu", "es"],
      transitionName: "slide-left",
    };
  },
  beforeRouteUpdate(to, from, next) {
    const toDepth = to.path.split("/").length;
    const fromDepth = from.path.split("/").length;
    this.transitionName =
      toDepth == fromDepth
        ? "fade"
        : toDepth < fromDepth
        ? "slide-right"
        : "slide-left";
    // console.log('transicion', this.transitionName, toDepth, fromDepth, to)
    next();
  },
  computed: {
    bono() {
      return this.$store.state.bonoName;
    },
    bonoActual() {
      return this.$store.state.bonoActual;
    },
  },
  methods: {
    scrollTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
    setLocale(lang) {
      const idioma = this.idiomas.find((locale) => locale == lang);
      if (idioma) {
        this.$cookie.set("lang", lang, { expires: 7 });
        this.$i18n.locale = lang;
        const parametros = this.$route.params;
        parametros.lang = lang;
        const ruta = this.$route.name;

        this.$router.replace({ params: parametros });
        // console.log('ruta', this.$route, parametros)
        // -- console.log('lang', lang)
      }
    },
  },
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.75s ease;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.child-view {
  /* position: absolute; */
  transition: all 0.3s cubic-bezier(0.55, 0, 0.1, 1);
}
.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  -webkit-transform: translate(30px, 0);
  transform: translate(30px, 0);
}
.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  -webkit-transform: translate(-30px, 0);
  transform: translate(-30px, 0);
}
</style>
